<template>
<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-color-colorselection`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_e8c74bc251__clip0_9572_43841)"><path d="M17.7818 13.7797L13.7002 17.8612C12.5122 19.0493 11.9181 19.6433 11.2331 19.8659C10.6306 20.0616 9.98158 20.0616 9.37905 19.8659C8.69406 19.6433 8.10004 19.0493 6.91199 17.8612L6.22455 17.1738C5.0365 15.9857 4.44247 15.3917 4.21991 14.7067C4.02414 14.1042 4.02414 13.4552 4.21991 12.8526C4.44247 12.1676 5.0365 11.5736 6.22455 10.3856L10.3061 6.30402L17.7818 13.7797ZM10.3061 6.30402L6.83203 2.82996M17.7818 13.7797H8.3808" stroke="#165DFF" stroke-width="1.66" stroke-linecap="round" stroke-linejoin="round"/><path d="M18.8926 15.83L20.6603 17.5977C21.6367 18.574 21.6367 20.1569 20.6603 21.1333C19.684 22.1096 18.1011 22.1096 17.1248 21.1333C16.1485 20.1569 16.1485 18.574 17.1248 17.5977L18.8926 15.83Z" :fill="useCurrentColor ? 'currentColor' : '#00BBD8'"/></g><defs><clipPath id="svg_e8c74bc251__clip0_9572_43841"><path :fill="useCurrentColor ? 'currentColor' : '#fff'" d="M0 0H24V24H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconColorColorselection',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
